import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { navPerf } from "@/lib/navPerf";

/**
 * Observes router location changes and records them into the current navPerf session.
 * This is intentionally lightweight and only does work if a perf session is active.
 */
export const PerfRouteObserver = () => {
  const location = useLocation();

  useEffect(() => {
    navPerf.mark("router:location", {
      pathname: location.pathname,
      search: location.search,
      key: location.key,
    });
  }, [location.key]);

  return null;
};
